import * as PropTypes from "prop-types";
import SwitchSvg from "./switch.svg";
import Icon from "./Icon";

export default function SwitchIcon({ className, style }) {
  const localStyle = {
    maxWidth: "1.25rem",
    maxHeight: "1.25rem",
    ...style,
  };

  return <Icon src={SwitchSvg} className={className} style={localStyle} />;
}

SwitchIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

SwitchIcon.defaultProps = {
  className: "",
  style: {},
};
